/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Email_LabelInputs */

const en_login_page_email_label = /** @type {(inputs: Login_Page_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

const de_login_page_email_label = /** @type {(inputs: Login_Page_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse`)
};

const pt_br2_login_page_email_label = /** @type {(inputs: Login_Page_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endereço de e-mail`)
};

const tr_login_page_email_label = /** @type {(inputs: Login_Page_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta adresi`)
};

const zh_cn2_login_page_email_label = /** @type {(inputs: Login_Page_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮箱地址`)
};

const zh_hk2_login_page_email_label = /** @type {(inputs: Login_Page_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電郵地址`)
};

const ko_kr2_login_page_email_label = /** @type {(inputs: Login_Page_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소`)
};

const ru_ru2_login_page_email_label = /** @type {(inputs: Login_Page_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес электронной почты`)
};

const es_419_login_page_email_label = /** @type {(inputs: Login_Page_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico`)
};

/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Login_Page_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_email_label = /** @type {((inputs?: Login_Page_Email_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Email_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_email_label(inputs)
	if (locale === "de") return de_login_page_email_label(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_email_label(inputs)
	if (locale === "tr") return tr_login_page_email_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_email_label(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_email_label(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_email_label(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_email_label(inputs)
	return es_419_login_page_email_label(inputs)
});